import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const smartSkinScanBannerSelector = createSelector(testTargetOffersSelector, offers => offers.smartSkinScanBanner || Empty.Object);

export { smartSkinScanBannerSelector };
